export { default as HeroLayout } from './HeroLayout.js';
export { default as TextLayout } from './TextLayout.js';
export { default as TextImageLayout } from './TextImageLayout.js';
export { default as GridLayout } from './GridLayout.js';
export { default as GalleryLayout } from './GalleryLayout.js';

export const layouts = [
    {
        id: 'hero',
        name: 'Hero layout',
        description: 'Stor hero sektion med overskrift og tekst herunder',
        preview: (
            <div className="w-full aspect-video bg-gray-100 rounded-lg p-2">
                <div className="h-1/2 bg-amber-200 rounded mb-2"></div>
                <div className="space-y-1">
                    <div className="h-2 w-3/4 bg-gray-300 rounded"></div>
                    <div className="h-2 w-1/2 bg-gray-300 rounded"></div>
                </div>
            </div>
        )
    },
    {
        id: 'text',
        name: 'Kun tekst',
        description: 'Ren tekstside uden hero sektion',
        preview: (
            <div className="w-full aspect-video bg-gray-100 rounded-lg p-2">
                <div className="space-y-2">
                    <div className="h-2 w-full bg-gray-300 rounded"></div>
                    <div className="h-2 w-full bg-gray-300 rounded"></div>
                    <div className="h-2 w-3/4 bg-gray-300 rounded"></div>
                </div>
            </div>
        )
    },
    {
        id: 'text-image',
        name: 'Tekst med billede',
        description: 'Tekst og billede side om side uden hero sektion',
        preview: (
            <div className="w-full aspect-video bg-gray-100 rounded-lg p-2">
                <div className="flex gap-2 h-full">
                    <div className="flex-1 space-y-2">
                        <div className="h-2 w-full bg-gray-300 rounded"></div>
                        <div className="h-2 w-full bg-gray-300 rounded"></div>
                    </div>
                    <div className="w-1/3 bg-amber-200 rounded"></div>
                </div>
            </div>
        )
    },
    {
        id: 'gallery',
        name: 'Galleri med billeder og tekst',
        description: 'Præsenter projekter i et grid med billeder og tekst',
        preview: (
            <div className="w-full aspect-video bg-gray-100 rounded-lg p-2">
                <div className="grid grid-cols-2 gap-2">
                    <div className="bg-gray-300 rounded aspect-square"></div>
                    <div className="bg-gray-300 rounded aspect-square"></div>
                    <div className="bg-gray-300 rounded aspect-square"></div>
                    <div className="bg-gray-300 rounded aspect-square"></div>
                </div>
            </div>
        )
    }
];